<template>
  <div class="wdgt-container" ref="container">
    <span v-if="!customerBookings" class="mb-3">{{ $t('messages.loading') }}</span>
    <span v-if="customerBookings && customerBookings.length === 0" class="mb-3">{{ $t('messages.emptyModifiableBookings') }}</span>
    <div class="clear-both"></div>
    <table v-if="customerBookings && customerBookings.length > 0">
      <thead>
        <tr>
          <th class="wdgt-date">{{ $t('words.date') }}</th>
          <th class="wdgt-product">{{ $t('words.product') }}</th>
          <th class="wdgt-actions">{{ $t('words.actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in customerBookings" :key="index+'-'+item.id">
          <td class="wdgt-date">{{ formatDateTime(toDate(item.startsAt)) }}</td>
          <td class="wdgt-product">{{ item.product.name }}</td>
          <td class="wdgt-actions">
            <button v-if="item.status === 'paid'" type="button" @click="changeBooking(item)" class="btn-change">
              {{ $t('actions.change') }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import BookingRepository from "@/api/BookingRepository";
import filterMixin from "@/mixins/filterMixin";
export default {
  props: {
    filters: { type:Object, required: false},
    orders: { type:Object, required: false}
  },
  mixins: [filterMixin],
  data() {
    return {
      customerBookings : null,
    }
  },
  created() {
    this.getCustomerBookings();
  },

  methods: {
    async getCustomerBookings() {
      const response = await BookingRepository.customerBookings(this.filters,this.orders);
      this.customerBookings = response.data.items;
    },
    changeBooking(item) {
      // Lógica para cambiar la reserva
      console.log('Changing booking:', item);
    }
  }
}
</script>

<style scoped>

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dedede;
  border-right: none;
  border-bottom: none;
  border-radius: 5px;
  color: #464958;
  margin: auto auto 15px;
  font-size: 16px;
  overflow-x: auto;
  white-space: nowrap;
}

thead {
  background-color: #fafafa;
}

th,
td {
  border: 1px solid #dedede;
  border-left: none;
  border-top: none;
  padding: 5px;
  vertical-align: middle;
}
i.material-icons-round {
  font-size: 16px;
  vertical-align: middle;
}
</style>
